// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3Y-xq","dragIcon":"Choice_dragIcon__4Xe5W","left":"Choice_left__kHC0c","input":"Choice_input__oK4se"};